export const ExternalSwitches = {
  WEB_ATTRIBUTION_SURVEY: "web_attribution_survey_v2",
  WEB_EXTERNAL_PARENTS_FIRST: "web_external_parents_first_v2",
  WEB_EXTERNAL_MOBILE_A_A: "web_external_mobile_a_a_v2",
  WEB_EXTERNAL_AI_SUPPORT: "web_external_ai_support",
  WEB_EXTERNAL_WHATSNEW: "web_external_whatsnew_v3",
  WEB_EXTERNAL_TRYITOUT: "web_external_try_it_out_v2",
  WEB_EXTERNAL_DISTRICTS_PAGE: "web_external_district_page_nav",
  WEB_EXTERNAL_MOBILE_STICKY_SIGNUP: "web_external_mobile_sticky_signup",
} as const;

export const TeacherSwitches = {
  WEB_MKT_DOJO_ISLANDS: "web_marketing_dojo_islands_entrypoints",
} as const;

export const featureSwitches = Object.values({ ...ExternalSwitches, ...TeacherSwitches });
